import { Popover } from 'antd';
import React from 'react';
import SelectedOption from '../SelectedOption/SelectedOption';
import getName from '../../../../helpers/getName';
import styles from './HiddenSelectedOptions.module.scss';

export const HiddenSelectedOptions = ({
  hiddenItems = [],
  handleItemRemove,
}) => {
  return (
    <Popover
      trigger="click"
      placement="bottom"
      content={
        <div className={styles.hiddenItemsList}>
          {hiddenItems.map((item) => (
            <SelectedOption
              key={item.id}
              text={getName(item)}
              value={item.id}
              onRemove={handleItemRemove}
            />
          ))}
        </div>
      }
    >
      <div className={styles.root}>{`+${hiddenItems.length}`}</div>
    </Popover>
  );
};
